import { SettingsPermissions } from "@redotech/account-common/permissions";
import { directMerchantAccess } from "../../settings-catalog/access";
import type {
  SettingGroupDefinition,
  SettingOwner,
  SettingRisk,
} from "../../settings-catalog/types";

export type InternationalMarketsEditorFlatTeamSettingGroupId =
  "international_markets_editor.market_editor";

const groupOwner: SettingOwner = {
  kind: "teamSettings",
  product: "fulfillment",
};

const groupRisk: SettingRisk = {
  level: "low",
  reason: "International shipping settings including customs and markets.",
};

export const InternationalMarketsEditorFlatTeamSettingGroups = [
  {
    id: "international_markets_editor.market_editor",
    title: "Market editor",
    description:
      "Market editor settings on the International markets editor page.",
    productArea: "fulfillment",
    access: directMerchantAccess(
      SettingsPermissions.SET_ORDER_FULFILLMENT_SETTINGS,
    ),
    owner: groupOwner,
    risk: groupRisk,
    agentEditability: { mode: "requiresApproval" },
    fullPageTarget: {
      type: "settings",
      // The editor route needs a concrete market id, so the group lands on
      // the markets list where the merchant picks one.
      path: "international/markets",
    },
    synonyms: ["market editor", "international markets editor"],
  },
] as const satisfies readonly SettingGroupDefinition<InternationalMarketsEditorFlatTeamSettingGroupId>[];

export const InternationalMarketsEditorFlatTeamSettingGroupById: Record<
  InternationalMarketsEditorFlatTeamSettingGroupId,
  SettingGroupDefinition<InternationalMarketsEditorFlatTeamSettingGroupId>
> = (() => {
  const map: Partial<
    Record<
      InternationalMarketsEditorFlatTeamSettingGroupId,
      SettingGroupDefinition<InternationalMarketsEditorFlatTeamSettingGroupId>
    >
  > = {};
  for (const group of InternationalMarketsEditorFlatTeamSettingGroups) {
    map[group.id] = group;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
  return map as Record<
    InternationalMarketsEditorFlatTeamSettingGroupId,
    SettingGroupDefinition<InternationalMarketsEditorFlatTeamSettingGroupId>
  >;
})();
